import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { DEFAULT_ORNAMENT_VARIANT, deleteOrnament, fetchOrnament, regenerateOrnament } from "../../api/ornaments";
import { useResource } from "../../lib/useResource";
import DetailPage from "../../components/detail/DetailPage";
import AddVariantForm from "../../components/generate/AddVariantForm";
import OrnamentVariantFields from "../../components/generate/OrnamentVariantFields";
import { ornamentPresenter } from "../../components/models/presenters";
import { ErrorState, LoadingState, Page } from "../../components/ui";

export default function OrnamentView({ id }: { id: string }) {
  const { instance } = useMsal();
  const { data, error, loading, setData } = useResource(id, fetchOrnament);
  const [variant, setVariant] = useState(DEFAULT_ORNAMENT_VARIANT);

  if (loading || data === null) {
    return error ? <Page title="Ornament"><ErrorState message={error} /></Page> : <LoadingState h={400} />;
  }

  return (
    <DetailPage
      title="Ornament"
      galleryPath="/gallery/ornaments"
      data={data}
      presenter={ornamentPresenter}
      shading="pbr"
      addVariant={
        <AddVariantForm title="Generate another variant" onGenerate={async () => setData(await regenerateOrnament(instance, id, variant))}>
          <OrnamentVariantFields value={variant} onChange={setVariant} />
        </AddVariantForm>
      }
      onRegenerateModel={(model) =>
        regenerateOrnament(instance, id, {
          bowColor: model.bowColor,
          removeBackground: model.backgroundRemoved,
          removalMode: variant.removalMode,
        })
      }
      onDataChange={setData}
      onDelete={() => deleteOrnament(instance, id)}
    />
  );
}
